import Vue from 'vue';

export default ({ subject }) => (subject && subject.allow_add_discussion)
    || Vue.authorizationChecker.isGranted('role-moderator');
